import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDialog({center,name,pw}) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <button className=' yekan button clrtwo has-text-white' onClick={handleClickOpen}>
                مشاهده
            </button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                  در حال نمایش اطلاعات کاربری
                    {' '}
                    {center}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    نام کاربری :

                        {' '}
                        {name}

                        <br/>

                        کلمه عبور :
                        {' '}
                        {pw}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>

                    <Button onClick={handleClose} autoFocus>
                        بستن
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

